import React, { useState } from 'react'
import { Layout, Menu, message } from 'antd';
import { LogoutOutlined } from '@ant-design/icons'
import * as requests from '../../requests'
import LiveEvents from './live'
import AllEvents from './all';
import "./index.css"
import { useHistory } from 'react-router-dom';
const { Header, Content, Footer } = Layout;

export default function Events() {
  const [menuItem, setMenuItem] = useState<string>("live");
  const history = useHistory()
  const onMenuSelect = ({ key }: { key: string }) => {
    setMenuItem(key);
  }
  const logout = () => {
    requests.logout().then(() => {
      history.push("/home")
    }).catch((err) => {
      console.error("Error in logging out, contact admin :: ", err)
      message.error("Error in logging out, contact admin")
    })
  }
  return (
    <div>
      <Layout className="layout">
        <Header>
          <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['live']} onSelect={onMenuSelect} style={{ display: "inline-block" }}>
            <Menu.Item key="live" className='event-menu-item'>
              <b>Live</b>
            </Menu.Item>
            <Menu.Item key="all" className='event-menu-item'>
              <b>All</b>
            </Menu.Item>
          </Menu>
          <div style={{ display: "inline-block", color: "#fff", position: "absolute", right: "33px", cursor: "pointer" }} onClick={logout}>
            <LogoutOutlined /> Logout
          </div>
        </Header>
        <Content style={{ padding: '0 30px' }}>
          <div className="site-layout-content">
            {
              menuItem === 'live' ? <LiveEvents /> : <AllEvents />
            }
          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>Created by loki. Feel free to drop a mail to <a href='mailto:lokeshwaran411@gmail.com'>lokeshwaran411@gmail.com</a> for queries and feature requests</Footer>
      </Layout>
    </div>
  )
};